<template>
  <div class="baseForm">
    <div class="formDom">
      <Form ref="caseApplyForm" :dataSource="getBaseForm" id="caseApplyForm"></Form>
    </div>
  </div>
</template>

<script>
import Form from '@/components/GlobalForm'
import { forms } from './formData'
export default {
  name: 'Index',
  components: {
    Form
  },
  model: {
    prop: 'individual_case_support_funds',
    event: 'checkFunds'
  },
  props: {
    initData: {
      // 父组件传过来的表单默认值
      type: Object,
      default: () => {
        return {}
      }
    },
    checkDisabled: {
      type: Function,
      default: () => { }
    },
    checkDisplay: {
      type: Function,
      default: () => { }
    },
    individualCaseSupportFunds: {
      type: String,
      default: ''
    },
    pageType: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {}
  },
  computed: {
    params() {
      return {
        checkDisabled: this.checkDisabled || (() => { }),
        checkDisplay: this.checkDisplay || (() => { }),
        checkFund: this.checkFund || (() => { })
      }
    },
    getBaseForm() {
      // 获取formData
      return forms.getBaseForm(this._.cloneDeep(this.initData), this.params, this.pageType)
    }
  },
  methods: {
    // // 数字输入框
    // numberChange (value) {
    //   let newValue = value
    //   newValue = newValue.replace(/[^\d.]/g, '')// 清除“数字”和“.”以外的字符
    //   newValue = newValue.replace(/^\./g, '')// 验证第一个字符是数字而不是.
    //   newValue = newValue.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的.
    //   newValue = newValue.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
    //   setTimeout(() => {
    //     this.$refs.baseFormDom.setFieldsValue('num', newValue)
    //   }, 0)
    // },
    // 设置业务事项，被兄弟组件调用
    // setYewushixiang(val) {
    //   alert(666)
    //   console.log('设置业务事项，被兄弟组件调用', this.initData)
    //   // this.initData.
    // },
    getValue(params) {
      // 获取数据
      const data = this.$refs.caseApplyForm.getFieldsValue(params)
      return data
    },
    onSubmit(params) {
      // 校验并获取数据
      const data = this.$refs.caseApplyForm.handleSubmit(params)
      return data
    },
    checkFund(value, id) {
      let newValue = value
      newValue = newValue.replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
      newValue = newValue.replace(/^\./g, '') // 验证第一个字符是数字而不是.
      newValue = newValue.replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的.
      newValue = newValue
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
      this.$emit('checkFunds', newValue)
      setTimeout(() => {
        this.$refs.caseApplyForm.setFieldsValue(id, newValue)
      }, 0)
    }
  }
}
</script>

<style scoped lang="less">
.formDom {
  /deep/ .ant-alert {
    padding: 5px 5px 5px 35px;
    font-size: 12px;
    .ant-alert-icon {
      top: 8px;
    }
  }
  .show {
    color: #3d73dd;
    cursor: pointer;
  }
  .show:hover {
    color: #4d86ff;
  }
  .personList {
    position: relative;
    border: 1px solid #e8e8e8;
    /deep/ .ant-table-wrapper {
      border-radius: 2px;
    }
    /deep/ .ant-table-placeholder {
      border-bottom: none;
    }
  }
}

// #caseApplyForm {
  /deep/  .ant-input[disabled] {
    color: rgba(0, 0, 0, 0.65);
    background-color: white;
    border: 0;
    cursor: text;
    opacity: 1;
  }
// }
</style>
